import type { MenuItem } from "@/utils/types";

export function usePanelDesktopMenu() {
  const menuItems = ref<MenuItem[]>([
    {
      label: "Strona główna",
      to: "/",
      icon: "Home",
    },
    {
      label: "Dziennik",
      to: "/journal",
      icon: "Journal",
    },
    {
      label: "Decyzje",
      to: "/decisions",
      icon: "Decisions",
    },
    {
      label: "Checkboxes",
      to: "/checkboxes",
      icon: "Checkboxes",
    },
    {
      label: "Rozliczenia",
      to: "/settlements",
      icon: "Settlements",
    },
    {
      label: "Dokumenty",
      to: "/documents",
      icon: "Documents",
    },
    {
      label: "Harmonogram",
      to: "/schedule",
      icon: "Schedule",
    },
    {
      label: "Kontakt",
      to: "/contact",
      icon: "Contact",
    },
  ]);

  return { menuItems };
}
